import React from 'react';
import {useTranslation} from 'react-i18next';
import DebouncedTextInput from '../../../../../components/slides/highlighted/common/debounced/DebouncedTextInput';

interface SearchBarProps {
    onSearch: (value: string) => void;
    value?: string;
}

export function SearchBar(props: SearchBarProps): JSX.Element | null {
    const {onSearch, value = ''} = props;

    const {t} = useTranslation();

    return (
        <div data-cy="search_bar">
            <DebouncedTextInput
                leading="solar:magnifer-linear"
                className="c-genericTable__toolbar_searchBar"
                onChange={onSearch}
                value={value}
                placeholder={t('genericTable.filter')}
            />
        </div>
    );
}

export default SearchBar;
